//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      title: 'Authenticator-双重认证密码管理器-浩海新程',
      aLists: []
    }
  },
  computed: {
  },
  methods: {
    openUrl () {
      window.location.href = 'https://apps.apple.com/us/app/%E8%93%9D%E7%8B%90%E7%9B%92%E5%AD%90-%E6%9C%AC%E5%9C%B0%E6%96%87%E4%BB%B6%E9%98%85%E8%AF%BB%E5%99%A8/id1628998734'
    },
  },
  mounted: function () {
    this.$nextTick(function () {
      
    })
  }
}



// WEBPACK FOOTER //
// ./src/router/Validator.vue